import {ITableReportDataRequestParams} from 'store/slices/table-report-slice/table-report-slice-types';

export enum EActionType {
  BUTTON = 'BUTTON',
  UPLOAD_FILE = 'UPLOAD_FILE',
}

export enum EActiveCondition {
  ALWAYS = 'ALWAYS',
  ONE_ROW_ONLY = 'ONE_ROW_ONLY',
  ANY_ROWS = 'ANY_ROWS',
}
export interface IReportConfigurationAction {
    id: number;
    action: string;
    function: string;
    program: string;
    active: boolean;
    actionType: EActionType;
    meaning: string;
    activeCondition: EActiveCondition;
}

interface IBaseActionDataArgs {
  docId?: string | null;
  action: string;
  templateCode?: string;
}

export interface IPostUploadFileArgs extends IBaseActionDataArgs {
  files?: File[];
}

export interface IPostActionDataArgs extends IBaseActionDataArgs{
  selectedTableRows: number[];
  isAllRowsSelected: boolean;
  pageRequestDto?: Omit<ITableReportDataRequestParams, 'templateCode' | 'docId' | 'lookupType'>;
}
